export class CityDTO {
  public cityCode: string;
  public description: string;
  public status: string;
  public district: string;
  public user: string;
  public url: string;


  constructor(cityCode: string, description: string, status: string, district: string, user: string, url: string) {
    this.cityCode = cityCode;
    this.description = description;
    this.status = status;
    this.district = district;
    this.user = user;
    this.url = url;
  }
}
